import Phaser from 'phaser';

export class InputManager {
  private readonly scene: Phaser.Scene;
  private readonly onFlap: () => void;
  private cursors?: Phaser.Types.Input.Keyboard.CursorKeys;
  private spaceKey?: Phaser.Input.Keyboard.Key;
  private enterKey?: Phaser.Input.Keyboard.Key;

  constructor(scene: Phaser.Scene, onFlap: () => void) {
    this.scene = scene;
    this.onFlap = onFlap;
  }

  bind(): void {
    this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onFlap);

    if (!this.scene.input.keyboard) {
      return;
    }

    this.cursors = this.scene.input.keyboard.createCursorKeys();
    this.spaceKey = this.scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
    this.enterKey = this.scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER);
  }

  update(): void {
    if (
      (this.spaceKey && Phaser.Input.Keyboard.JustDown(this.spaceKey)) ||
      (this.enterKey && Phaser.Input.Keyboard.JustDown(this.enterKey)) ||
      (this.cursors?.up && Phaser.Input.Keyboard.JustDown(this.cursors.up))
    ) {
      this.onFlap();
    }
  }

  destroy(): void {
    this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onFlap);
  }
}
